import Link from '@/_application/core/components/ui/link';
import {useScrollHeight} from '@/_application/core/hooks/useScrollHeight';
import CheckIcon from '@/_application/icons/check-icon';
import {HelpIcon} from '@/_application/icons/help-icon';
import LogoIcon from '@/_application/icons/logo-icon';
import {ShoppingBagIcon} from '@/_application/icons/shopping-bag-icon';
import cn from 'classnames';
import {motion, useAnimation} from 'framer-motion';
import {usePathname} from 'next/navigation';
import {useEffect} from 'react';
import Sidebar from '../sidebar/kidsplaza-spring.desktop.sidebar';
import {useWindowSize} from '@/_application/core/hooks/useWindowSize';
import {Routes} from '@/config/routes';
import {CategoryListQuery} from '@/framework/gql/categoryList.graphql';

interface IProps {
    categories: CategoryListQuery['categoryList'];
}

const SubNavigationBar: React.FC<IProps> = ({categories}) => {
    const windowSize = useWindowSize();
    const pathname = usePathname();
    const isHidePage = pathname?.startsWith(Routes.cart) || pathname?.startsWith(Routes.checkout);
    const isHome = pathname === Routes.home;
    const isShowSubNavigation = useScrollHeight(426);
    const controls = useAnimation();

    useEffect(() => {
        if (!isHome) {
            controls.start({opacity: 1});
            return;
        }

        controls.start({
            opacity: !isShowSubNavigation && windowSize.width > 1024 ? 0 : 1,
        });
    }, [isShowSubNavigation, controls, windowSize.width, isHome]);

    if (isHidePage) {
        return null;
    }

    return (
        <motion.div
            initial={{opacity: 1}}
            animate={isHome ? controls : {opacity: 1}}
            transition={{duration: 0.4}}
            className={cn('flex items-center justify-center bg-KPZ_Yellow py-[3px] pb-1 text-primary', {
                'lg:hidden': isHome && !isShowSubNavigation,
            })}>
            <div className="flex w-[698px] items-center justify-between text-sm font-extrabold lg:w-[950px] xl:w-[1198px]">
                <Sidebar isHeader={true} categories={categories} />
                <div className="flex items-center justify-center gap-2">
                    <ShoppingBagIcon className="w-4.5 h-4.5" />
                    <Link href={`${Routes.storeNearYou}`} className="text-sm transition-colors hover:text-white">
                        Zalo cửa hàng
                    </Link>
                </div>
                <div className="flex items-center justify-center gap-2">
                    <CheckIcon className="h-5 w-5" />
                    <Link href={`${Routes.appDownload}`} className="text-sm transition-colors hover:text-white">
                        Ưu đãi khi tải app
                    </Link>
                </div>
                <div className="flex items-center justify-center gap-2">
                    <LogoIcon className="h-5 w-5" />
                    <Link href={`${Routes.memberIncentives}`} className="text-sm transition-colors hover:text-white">
                        Thưởng Kicoin
                    </Link>
                </div>
                <div className="hidden items-center justify-center gap-2 lg:flex">
                    <HelpIcon width="20px" height="20px" />
                    <a href="tel:18006608" className="text-sm transition-colors hover:text-white">
                        Hotline: 1800.6608
                    </a>
                </div>
            </div>
        </motion.div>
    );
};

export default SubNavigationBar;
